module.exports = __webpack_public_path__ + "media/Farol.87e8563f.mp3";